<template>
  <div>
    <div class="px-md-12 px-lg-12 pr-4 pt-12">
      <div class="mb-4">
        <strong class="my-title">
          Preencha a Declaração <br />
          Pessoal de Saúde – DPS
        </strong>
      </div>

      <v-row dense class="ma-0 pa-0">
        <v-form
          ref="form"
          class="d-flex justify-center align-center flex-wrap mx-auto"
        >
          <v-col cols="12" sm="12" md="6" lg="6">
            <strong>Peso</strong>
            <v-text-field
              v-model="user.weight"
              class="input-field"
              background-color="#f5f5f5"
              :rules="[(v) => !!v || 'Peso obrigatório']"
              outlined
              type="number"
              min="0"
              placeholder="80"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="6" lg="6">
            <strong>Altura</strong>
            <v-text-field
              v-model="user.height"
              class="input-field"
              background-color="#f5f5f5"
              :rules="[(v) => !!v || 'Peso obrigatório']"
              outlined
              type="number"
              min="0"
              placeholder="1.80"
            >
            </v-text-field>
          </v-col>
        </v-form>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong> Você sofre ou já sofreu de alguma doença crônica? </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.chronicDisease.value = true"
            class="mr-3"
            :class="user.chronicDisease.value ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.chronicDisease.value = false"
            :class="!user.chronicDisease.value ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-expand-transition>
          <v-col v-if="user.chronicDisease.value == true" cols="11">
            <strong>
              Indique qual foi a doença e explique (Conte-nos mais detalhes
              sobre o que teve. Informe a doença, a data do diagnóstico e o
              tratamento realizado).
            </strong>
            <v-textarea
              class="priamry-input"
              outlined
              rows="3"
              placeholder="Digite aqui informções sobre a doença."
              v-model="user.chronicDisease.description"
            ></v-textarea>
          </v-col>
        </v-expand-transition>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Você já foi submetido a algum procedimento hospitalar?
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.hospitalProcedure.value = true"
            class="mr-3"
            :class="user.hospitalProcedure.value ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.hospitalProcedure.value = false"
            :class="!user.hospitalProcedure.value ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-expand-transition>
          <v-col v-if="user.hospitalProcedure.value == true" cols="11">
            <strong>
              Indique qual foi o procedimento (Conte-nos mais detalhes sobre o
              procedimento. Informe o procedimento, a data e o motivo.)
            </strong>
            <v-textarea
              class="priamry-input"
              outlined
              rows="3"
              placeholder="Digite aqui informções sobre o procedimento."
              v-model="user.hospitalProcedure.description"
            ></v-textarea>
          </v-col>
        </v-expand-transition>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Você faz uso diário ou habitual de medicamentos? (Em caso de uso de
            pílula contraceptiva e/ou medicamento para calvície, assinale
            "Não".)
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.medicationRegularly.value = true"
            class="mr-3"
            :class="user.medicationRegularly.value ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.medicationRegularly.value = false"
            :class="!user.medicationRegularly.value ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-expand-transition>
          <v-col v-if="user.medicationRegularly.value == true" cols="11">
            <strong>
              Conte-nos mais detalhes sobre o(s) medicamento(s). Informe o
              medicamento, a dose, a frequência de uso e o diagnóstico
            </strong>
            <v-textarea
              class="priamry-input"
              outlined
              rows="3"
              placeholder="Digite aqui informções sobre os medicamentos."
              v-model="user.medicationRegularly.description"
            ></v-textarea>
          </v-col>
        </v-expand-transition>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Sofre de alguma deficiência nos órgãos, nos membros ou nos sentidos?
            (Não é necessário informar deficiência visual menor que 10 graus
            para miopia, astigmatismo ou hipermetropia.)
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.deficient.value = true"
            class="mr-3"
            :class="user.deficient.value ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.deficient.value = false"
            :class="!user.deficient.value ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-expand-transition>
          <v-col v-if="user.deficient.value == true" cols="11">
            <strong>
              Conte-nos mais detalhes sobre sua deficiência. Informe a
              deficiência, a causa, a data do diagnóstico e o tratamento
              realizado
            </strong>
            <v-textarea
              class="priamry-input"
              outlined
              rows="3"
              placeholder="Digite aqui informções sobre a deficiência."
              v-model="user.deficient.description"
            ></v-textarea>
          </v-col>
        </v-expand-transition>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Algum membro da sua família (pais ou irmãos) sofre ou já sofreu de
            alguma doença grave?
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.familiarWithDisease.value = true"
            class="mr-3"
            :class="user.familiarWithDisease.value ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.familiarWithDisease.value = false"
            :class="!user.familiarWithDisease.value ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-expand-transition>
          <v-col v-if="user.familiarWithDisease.value == true" cols="11">
            <strong>
              Indique a doença (Conte-nos mais detalhes sobre a(s) doença(s) do
              seu familiar. Informe o grau de parentesco e a idade que tinha
              quando diagnosticado.)
            </strong>
            <v-textarea
              class="priamry-input"
              outlined
              rows="3"
              placeholder="Digite aqui informções sobre a doença."
              v-model="user.familiarWithDisease.description"
            ></v-textarea>
          </v-col>
        </v-expand-transition>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Você consome bebida alcoólica mais do que 3 vezes por semana?
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.consumesAlcohol.value = true"
            class="mr-3"
            :class="user.consumesAlcohol.value ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.consumesAlcohol.value = false"
            :class="!user.consumesAlcohol.value ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-expand-transition>
          <v-col v-if="user.consumesAlcohol.value == true" cols="5">
            <strong
              >Houve necessidade de tratamento para dependência
              alcoólica?</strong
            >
            <v-select
              class="priamry-input"
              outlined
              placeholder="Selecione"
              :items="['Sim', 'Não']"
              v-model="user.consumesAlcohol.wasTreatment"
            ></v-select>
          </v-col>
        </v-expand-transition>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Faz ou fez uso de tabaco nos últimos 3 anos (mais de 30 unidades por
            dia)?
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.consumeTobacco.value = true"
            class="mr-3"
            :class="user.consumeTobacco.value ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.consumeTobacco.value = false"
            :class="!user.consumeTobacco.value ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Faz ou fez uso de algum tipo de droga nos últimos 5 anos?
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.consumeDrugs.value = true"
            class="mr-3"
            :class="user.consumeDrugs.value ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.consumeDrugs.value = false"
            :class="!user.consumeDrugs.value ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-expand-transition>
          <v-col v-if="user.consumeDrugs.value == true" cols="11">
            <v-col cols="5">
              <strong>Houve necessidade de internação?</strong>
              <v-select
                class="priamry-input"
                outlined
                placeholder="Selecione"
                :items="['Sim', 'Não']"
                v-model="user.consumeDrugs.washospitalized"
              ></v-select>
            </v-col>
            <v-expand-transition>
              <div v-if="user.consumeDrugs.washospitalized == 'Sim'">
                <strong
                  >Indique as drogas e Conte-nos mais sobre a droga utilizada
                  Informe o produto, a quantidade, a frequência de uso e a
                  última vez que usou.</strong
                >
                <v-textarea
                  class="priamry-input mt-3"
                  outlined
                  rows="3"
                  placeholder="Digite aqui informções sobre a internação."
                  v-model="user.consumeDrugs.description"
                ></v-textarea>
              </div>
            </v-expand-transition>
          </v-col>
        </v-expand-transition>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Você pratica alguma modalidade esportiva em caráter profissional ou
            amador?
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.practiceSports.value = true"
            class="mr-3"
            :class="user.practiceSports.value ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.practiceSports.value = false"
            :class="!user.practiceSports.value ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-expand-transition>
          <v-col v-if="user.practiceSports.value == true" cols="11">
            <strong>
              Conte-nos a categoria em que seu esporte se encaixa e indique qual
              o esporte que você pratica.
            </strong>
            <v-textarea
              class="priamry-input"
              outlined
              rows="3"
              placeholder="Digite aqui informções sobre a categoria e o esporte."
              v-model="user.practiceSports.description"
            ></v-textarea>
          </v-col>
        </v-expand-transition>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Sofreu alguma alteração de peso (perda ou ganho) de mais de 10kg nos
            últimos 6 meses?
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.lostMoreThanTenKilos.value = true"
            class="mr-3"
            :class="user.lostMoreThanTenKilos.value ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.lostMoreThanTenKilos.value = false"
            :class="!user.lostMoreThanTenKilos.value ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-expand-transition>
          <v-col v-if="user.lostMoreThanTenKilos.value == true" cols="11">
            <strong>
              Indique a alteração: Perda de peso ou Ganho de peso e o motivo da
              alteração de peso?
            </strong>
            <v-textarea
              class="priamry-input"
              outlined
              rows="3"
              placeholder="Digite aqui informções sobre a alteração de peso."
              v-model="user.lostMoreThanTenKilos.description"
            ></v-textarea>
          </v-col>
        </v-expand-transition>

        <v-col cols="12" sm="6" md="8" class="d-flex align-center mb-5">
          <strong>
            Alguma companhia já recusou, agravou/ajustou ou cancelou algum
            seguro de vida, acidentes pessoais ou coberturas de risco de
            previdência em seu nome?
          </strong>
        </v-col>
        <v-col cols="6" md="4" class="mb-5 d-flex align-center">
          <v-btn
            @click="user.canceledInsurance.value = true"
            class="mr-3"
            :class="user.canceledInsurance.value ? 'active' : ''"
          >
            Sim
          </v-btn>
          <v-btn
            @click="user.canceledInsurance.value = false"
            :class="!user.canceledInsurance.value ? 'active' : ''"
          >
            Não
          </v-btn>
        </v-col>

        <v-expand-transition>
          <v-col v-if="user.canceledInsurance.value == true" cols="11">
            <strong>Motivo:</strong>
            <v-select
              class="priamry-input"
              outlined
              placeholder="Selecione"
              :items="['Cancelado', 'Recusado', 'Agravado/Ajustavo']"
              v-model="user.canceledInsurance.reason"
              style="width: 40%"
            ></v-select>
            <strong
              >Conte-nos mais detalhes sobre seu antigo seguro. Informe a
              empresa, o capital segurado e o motivo</strong
            >
            <v-textarea
              class="priamry-input mt-3"
              outlined
              rows="3"
              placeholder="Digite aqui informções sobre a categoria e o esporte."
              v-model="user.canceledInsurance.description"
            ></v-textarea>
          </v-col>
        </v-expand-transition>
      </v-row>
      <div class="mb-6 mt-6 mr-2 d-flex justify-end">
        <v-btn
          class="next-button"
          @click="submit"
          elevation="0"
          height="44"
          :loading="loading"
        >
          <strong
            class="mr-2 next-button-label"
            style="color: var(--custom-white-second-color)"
          >
            Enviar Solicitação
          </strong>
          <v-icon style="color: var(--custom-white-second-color)"
            >mdi-arrow-right-circle-outline</v-icon
          >
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import moment from "moment";
import { saveSessionInfo } from "../../../../services/CoverService";

export default {
  name: "Payment",
  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      user: {
        chronicDisease: {
          value: false,
        },
        hospitalProcedure: {
          value: false,
        },
        medicationRegularly: {
          value: false,
        },
        deficient: {
          value: false,
        },
        familiarWithDisease: {
          value: false,
        },
        consumesAlcohol: {
          value: false,
        },
        consumeTobacco: {
          value: false,
        },
        consumeDrugs: {
          value: false,
        },
        practiceSports: {
          value: false,
        },
        lostMoreThanTenKilos: {
          value: false,
        },
        canceledInsurance: {
          value: false,
        },
      },
      generalOptions: [
        { text: "Sim", value: true },
        { text: "Não", value: false },
      ],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const storagedData = JSON.parse(
          localStorage.getItem("@GlobusVida:data")
        );
        const secures = JSON.parse(localStorage.getItem("covers"));
        const monthValue = JSON.parse(localStorage.getItem("monthValue"));

        this.user = {
          ...this.user,
          ...storagedData,
          covers: secures,
          monthValue: monthValue,
          queryInfos: JSON.parse(localStorage.getItem("queryInfos")),
        };

        localStorage.setItem("@GlobusVida:data", JSON.stringify(this.user));

        this.user.dataNascimento = moment(this.user.dataNascimento).format(
          "YYYY/MM/DD"
        );

        this.apiService
          .post("api/vida/criarcota", this.user)
          .then(async () => {
            await saveSessionInfo({ hired: true, otherData: this.user });
            this.loading = false;
            this.$toast.success("Solicitação enviada!");
            this.$emit("confirm");
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
            this.$toast.error("Erro ao enviar solicitação!");
          });
      }
    },
  },
};
</script>

<style scoped>
.active {
  background-color: var(--custom-primary-color) !important;
  color: var(--custom-white-second-color) !important;
}
</style>
